import { UpsertLabelModal } from '../UpsertLabel/UpsertLabelModal'
import { createEditButton } from '../../../../components'

// TODO Add subject / remove for good
export const LabelEditButton = createEditButton(UpsertLabelModal, 'categories' as never)
